import { Action, Location } from "history";
import { JSX, useEffect } from "react";
import { useBlocker } from "react-router-dom";

export type PromptProps = {
	when?: boolean;
	message: string;

	condition?: (nextPath: string) => boolean;
};

type BlockerFunctionArgs = {
	currentLocation: Location;
	nextLocation: Location;
	historyAction: Action;
};

function Prompt(props: PromptProps): JSX.Element {
	useBlocker((args: BlockerFunctionArgs): boolean => {
		const conditionMet =
			props.condition === undefined ||
			props.condition?.(args.nextLocation.pathname);
		if (props.when && conditionMet) {
			return !window.confirm(props.message);
		}
		return false;
	});

	useEffect(() => {
		const alertUser = (e: BeforeUnloadEvent): void => {
			e.preventDefault();
			e.returnValue = "";
		};

		if (props.when) {
			// TODO visibilitychange event.
			window.addEventListener("beforeunload", alertUser);
		}

		return () => {
			window.removeEventListener("beforeunload", alertUser);
		};
	}, [props]);

	return <></>;
}

export default Prompt;
